import { ToastController } from '@ionic/angular';
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ToastsService {
  constructor(private toastController: ToastController) {}

  async presentToast(message: string, duration: number, color: string, position?: any, icon?: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      color: color,
      icon: icon,
      position: position ? position: "top"
    });

    toast.present();

    return toast;

  }
  
  async presentToastWithButton(message: string, duration: number, color: string, position: any, buttons: any, icon?: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      color: color,
      icon: icon,
      position: position ? position: "top",
      buttons: buttons
    });

    toast.present();

    return toast;

  }
}
